export function queryGrid (params = {}) {
  let filtros = {}
  // quantidade de registros
  filtros.qtd = params.take
  // pagina
  filtros.page = 1
  if (params.skip > 0) filtros.page = (params.skip / filtros.qtd) + 1
  // Where
  filtros = Object.assign({}, filtros, params.where || {})
  // Order BY
  if (params.sort && params.sort[0]) {
    filtros.order = []
    let sort = params.sort[0]
    filtros.order.push(sort.selector)
    filtros.order.push(sort.desc ? 'desc' : 'asc')
  }
  // Retorna
  return filtros
}

export function setFocus (seletor, contexto) {
  let el = window.$(seletor, contexto)
  if (el[0]) {
    el = window.$(el[0])
    let x = 0
    let int = setInterval(function () {
      el.focus()
      x++
      if (el.is(':focus') || x === 10) clearInterval(int)
    })
  }
}
